import React from 'react';

import { arrayOf, bool, node, oneOfType } from 'prop-types';

import LoadingSpinner from '../.deprecated/loading_spinner/LoadingSpinner';

import './Tab.scss';

const Tab = props => {
  const { children, loading } = props;

  return (
    <div>
      {loading ? (
        <div className="tab__spinner-container">
          <LoadingSpinner
            size="small"
            color="primary"
            className="tab-content-loading-spinner"
          />
        </div>
      ) : (
        children
      )}
    </div>
  );
};

Tab.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  loading: bool
};

Tab.defaultProps = {
  children: undefined,
  loading: false
};

export default Tab;
